import { render, staticRenderFns } from "./RoleSwitch.vue?vue&type=template&id=7f1a8462&scoped=true&"
import script from "./RoleSwitch.vue?vue&type=script&lang=js&"
export * from "./RoleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./RoleSwitch.vue?vue&type=style&index=0&id=7f1a8462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a8462",
  null
  
)

component.options.__file = "RoleSwitch.vue"
export default component.exports